import { render } from "./say.vue?vue&type=template&id=ae475300&scoped=true&bindings={\"say\":\"data\",\"str\":\"data\",\"strArray\":\"data\",\"sayingsArray\":\"data\",\"getStrArray\":\"options\",\"getSayingArray\":\"options\",\"switchSaying\":\"options\"}"
import script from "./say.vue?vue&type=script&lang=js"
export * from "./say.vue?vue&type=script&lang=js"

import "./say.vue?vue&type=style&index=0&id=ae475300&scoped=true&lang=less"
script.render = render
script.__scopeId = "data-v-ae475300"

export default script